<template>
    <l-modal size="m" :close-on-backdrop-click="false" @close="cancel()">
        <template #header>
            {{ title || $t("modal.labelSure") }}
        </template>
        <template #body>
            <div v-if="image" class="tw-mb-4">
                <img :src="image" alt="Image" class="congrats-modal-image" />
                <hr />
            </div>
            <div>
                {{ text }}
            </div>
            <l-space :size="1" />
            <div class="footer">
                <button v-if="showCancel" class="btn btn-primary" type="button" @click="cancel()">
                    <span>{{ labelCancel || $t("modal.labelCancel") }}</span>
                </button>
                <button class="btn btn-primary btn-raised" type="button" @click="confirm()">
                    <span>{{ labelConfirm || $t("modal.labelConfirm") }}</span>
                </button>
            </div>
        </template>
    </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import LSpace from "@/components/LSpace";

export default {
    components: {
        LModal,
        LSpace,
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            default: "",
        },
        labelCancel: {
            type: String,
            default: "",
        },
        labelConfirm: {
            type: String,
            default: "",
        },
        showCancel: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
